import './leads.less';
import React from 'react';

import {inject, observer} from 'mobx-react';

import {Loading} from '../../../common/loading';
import {LeadItem} from './lead-item';
import {withRouter} from 'react-router-dom';
import {PageFooterNav} from '../common/page-footer-nav';

@withRouter
@inject("leadStore")
@inject("loginStore")
@observer
export class Leads extends React.Component {
  componentWillMount() {
    let page = 1, pageSize = 50;

    const query = new URLSearchParams(this.props.location.search);

    if (query.get('page')) {
      page = parseInt(query.get('page'));
    }
    if (query.get('pageSize')) {
      pageSize = parseInt(query.get('pageSize'));
    }

    this.props.leadStore.resetFilters();
    this.props.leadStore.changePageAndLoad(page, pageSize);
  }

  render() {
    const { isLoading, loadError, leads, filters, pageSize, page, total } = this.props.leadStore;

    return (
      <div className="lead-page">
        <div className="lead-list">
          <h1>Заявки</h1>

          {isLoading && <Loading />}
          {!isLoading && loadError && (
            <div className="lead-load-error">
              Ошибка загрузки: {loadError}
            </div>
          )}
          {!isLoading && (
            <React.Fragment>
              <div className="lead-item lead-list-header">
                <div className="lead--status"></div>
                <div className="lead--date">Дата</div>
                <div className="lead--source">Источник</div>
                <div className="lead--client">Клиент (ФИО)</div>
                <div className="lead--phone">Телефон</div>
                <div className="lead--form">Форма</div>
                <div className="lead--message">Сообщение</div>
                <div className="lead--comment">Комментарий</div>
                <div className="lead--actions">Действия</div>
              </div>
              {leads.map(item => <LeadItem lead={item} key={item.data._id} />)}
            </React.Fragment>
          )}

          <PageFooterNav
            page={page}
            pageSize={pageSize}
            total={total}
            onChangePagination={this.onChangePagination}

            filters={filters}
            patchFilters={data => this.props.leadStore.patchFilters(data)}
            applyFilters={() => this.props.leadStore.load()}
          />
        </div>
      </div>
    );
  }

  onChangePagination = (page, pageSize) => {
    this.props.leadStore.changePageAndLoad(page, pageSize);
    this.props.history.push(`?page=${page}&pageSize=${pageSize}`);
  };


}



// WEBPACK FOOTER //
// ./src/components/pages/crm/lead/leads.js